// Шалгалт — нийтлэг туслахууд
import moment from "moment";

export const fmtWhen = (d) => (d ? moment(d).format("MM/DD HH:mm") : "");
const r2 = (v) => Math.round(Number(v || 0) * 100) / 100;
export const scoreText = (r) => (r ? `${r2(r.score)} / ${r2(r.maxScore)}${r.pending ? "*" : ""}` : "");

// 754 сек → "12:34", 3700 → "1:01:40"
export const fmtClock = (sec) => {
  const s = Math.max(0, Math.floor(sec));
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  const ss = String(s % 60).padStart(2, "0");
  return h ? `${h}:${String(m).padStart(2, "0")}:${ss}` : `${m}:${ss}`;
};

export const TYPE_HINT = {
  single: "Нэг хариулт сонгоно",
  multiple: "Бүх зөв хариултыг сонгоно",
  short: "Богино хариулт бичнэ",
  number: "Тоогоор хариулна",
  long: "Дэлгэрэнгүй бичнэ",
  voice: "Хариултаа дуугаар бичиж илгээнэ",
  file: "Зураг эсвэл файл илгээнэ",
};

// Хариулсан эсэх
export const isAnswered = (a) => !!a && ((a.optionIds && a.optionIds.length > 0) || !!a.fileName || (a.text != null && String(a.text).trim() !== ""));
export const wordCount = (t) => String(t || "").trim().split(/\s+/).filter(Boolean).length;
